// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.3s ease;
}

.file-upload-container:hover,
.file-upload-container:focus-visible {
  border-color: #3f51b5;
  /* Primary color */
}

.file-upload-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #3f51b5;
  /* Primary color */
  font-weight: bold;
  cursor: pointer;
}

.file-upload-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.file-upload-container:focus-within {
  border-color: #3f51b5;
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.text-sm {
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dispute-resolution/file-upload/file-upload.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AACF;;AAEA;;EAEE,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".file-upload-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1rem;\r\n  border: 2px dashed #ccc;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: border-color 0.3s ease;\r\n}\r\n\r\n.file-upload-container:hover,\r\n.file-upload-container:focus-visible {\r\n  border-color: #3f51b5;\r\n  /* Primary color */\r\n}\r\n\r\n.file-upload-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  color: #3f51b5;\r\n  /* Primary color */\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n\r\n.file-upload-input {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  border: 0;\r\n}\r\n\r\n.file-upload-container:focus-within {\r\n  border-color: #3f51b5;\r\n  outline: 2px solid #1976d2;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.text-sm {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
